import { getAcvParentOriginForPostMessage } from './acvParentOrigin';

/**
 * Tells the ACV host whether leaving AIRecording would lose a recording, so ACV can ask
 * before switching pages (the AIRecording iframe is removed on navigation).
 *   - 'recording': a recording is running (or paused)
 *   - 'unsaved':   recording finished, preview open, not saved yet
 *   - 'idle':      nothing to lose
 *
 * Host: ACVNNS-Frontend/src/components/AiRecordingLeaveGuard.js.
 * The host can reply with { type: 'acv-airecording-stop-recording' } to stop the recording.
 */
export type AcvRecordingState = 'idle' | 'recording' | 'unsaved';

export const ACV_RECORDING_STATE_MESSAGE = 'airecording-recording-state';
export const ACV_STOP_RECORDING_MESSAGE = 'acv-airecording-stop-recording';

export function notifyAcvRecordingState(state: AcvRecordingState): void {
  try {
    if (typeof window === 'undefined' || window.parent === window) return;
    const targetOrigin = getAcvParentOriginForPostMessage() ?? '*';
    window.parent.postMessage({ type: ACV_RECORDING_STATE_MESSAGE, state, source: 'aiRecording' }, targetOrigin);
  } catch {
    // ignore
  }
}
